
















import { Component, Vue, Provide } from "vue-property-decorator";
const ParameterConfiguration = () => import("./views/parameterConfiguration/index.vue");
const QuestionConfiguration = () => import("./views/questionConfiguration/index.vue");
const QuestionRules = () => import("./views/questionRules/index.vue");

@Component({
  name: "orderDeal",
  components: { ParameterConfiguration, QuestionConfiguration, QuestionRules },
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "first";
  private handleClick(tab: any, event: any) {
    // 点击tab,缓存
    localStorage.setItem("tabQuestion", tab.name);
  }
  private created() {
    // 刷新页面获取缓存或者默认值
    this.activeName = localStorage.getItem("tabQuestion") || "first";
  }
  private destroyed() {
    // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
    localStorage.setItem("tabQuestion", "first");
  }
}
